// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/HERO-BG.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_banner__1Tzy\\+ {
    display: flex;
    justify-content: space-between;
    align-items: end;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    height: 250px;
    position: relative;
    z-index: -1;
}

.AboutUs_bannerText__Wkeir {
    padding: 0 0 0 5%;
    min-width: 400px;
}

.AboutUs_bannerTitle__2XN7k {
    font-size: 60px;
    font-family: 'Cocon Bold', sans-serif;
    padding-bottom: 10px;
}

.AboutUs_container__B9FnG {
    margin: 50px 0px;
}

.AboutUs_bannerSubtitle__XXlUf {
    font-size: 26px;
    font-weight: 700;
    margin: 0;
    padding-left: 5px;
}

.AboutUs_webBanner__ovjNN {
    position: relative;
    right: 0;
    width: 60%;
}

.AboutUs_divider__VmYxB {
    height: 22px;
    width: 90%;
    margin-left: 90px;
    margin-right: 90px;
    background-color: #69bf4a;
    position: absolute;
    bottom: -11px;
    border-radius: 999px;
}

.AboutUs_buttons__-tyag {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    align-items: center;
    justify-content: space-evenly;
}

.AboutUs_buttons__-tyag button {
    position: relative;
    background: transparent;
    padding: 0px 10px 0px 10px;
    border-radius: 14px;
    color: #fff;
    cursor: pointer;
    border: 2px solid transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 51px;
    width: 170px;
    z-index: 1;
}
.AboutUs_buttons__-tyag a {
    text-decoration: none;
}
.AboutUs_buttons__-tyag .AboutUs_Safety__-NE4m {
    background: #69bf4a;
}
.AboutUs_buttons__-tyag .AboutUs_Safety__-NE4m img {
    height: 40px;
    position: relative;
    bottom: 5px;
    z-index: -1;
}
.AboutUs_buttonLabel__NWkMn {
    font-weight: 800;
    font-size: 24px;
}

.AboutUs_featured__Eq18N {
    margin-top: 28px;
}
.AboutUs_featuredTitle__WJo0V {
    font-style: normal;
    font-weight: 700;
    font-size: 38px;
    line-height: 75px;
    text-align: center;
    margin: 0;
    font-family: 'Cocon Bold', sans-serif;
}

.AboutUs_teamBrands__Cw59a {
    width: 90%;
    display: flex;
    gap: 20px;
    margin: 0 auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.AboutUs_teamBrands__Cw59a img {
    width: 18%;
    height: auto;
    cursor: pointer;
}
.AboutUs_bubble__u5TXR {
    width: 90%;
    background-image: linear-gradient(to right, #2acdc2, #63c15f);
    margin: 0 auto;
    margin-top: 2em;    
    color: #fff;
    border-radius: 99px;
    text-align: center;
    padding: 15px 0;
    font-size: 28px;
    font-family: 'Cocon Bold', sans-serif;
}

.AboutUs_teamMember__c6i5o {
    display: flex;
    width: 90%;
    gap: 11px;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 28px;
    justify-content: center;
}

.AboutUs_teamMember__c6i5o span {
    margin: o;
    font-size: 14px;
}

.AboutUs_teamMember__c6i5o img {
    height: 250px;
}

.AboutUs_teamMember__c6i5o  .AboutUs_teamMemberText__vw5a0 {
    width: 57%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.AboutUs_teamMember__c6i5o h4 {
    font-size: 28px;
    margin: 5px auto;
}

.AboutUs_teamMember__c6i5o h6 {
    font-size: 14px;
    margin: 5px auto;
}

.AboutUs_teamMember__c6i5o p {
    font-style: normal;
    font-size: 14px;
    line-height: 1.5em;
    text-align: center;
}
.AboutUs_teamMember__c6i5o .AboutUs_firstSentence__\\+W5cR {
    font-weight: 700;
}

.AboutUs_brandCard__zO1bL {
    width: 100%;
    height: 200px;
    background: transparent;
    box-shadow: 0px 0px 8.486px rgba(0, 0, 0, 0.24);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;
}
.AboutUs_brandCard__zO1bL img {
    width: 35%;
    height: auto;
    object-fit: contain;
}
.AboutUs_brandCardMain__IFcBw{
    width:40%;
}
.AboutUs_brandCardMain__IFcBw p {
    font-size: 14px;
    font-weight: 500;
    margin: 11px auto;
    text-align: center;
}
.AboutUs_articlesContainer__BMnrv {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 18px;
    gap: 2em;
}
.AboutUs_glow__mF1Yr {
    box-shadow: 0 0 30px #00ff00;
}


@media screen and (max-width: 1160px) {
    .AboutUs_bannerSubtitle__XXlUf {
        font-size: 20px;
    }

    .AboutUs_webBanner__ovjNN {
        opacity: 30%;
    }
}

@media screen and (max-width: 1035px) {
    .AboutUs_featured__Eq18N {
        margin-top: 18px;
    }
    .AboutUs_featuredTitle__WJo0V {
        font-style: normal;
        font-size: 24px;
        line-height: 75px;
    }
    .AboutUs_buttonArrow__2S6a\\+ {
        height: 35px;
        bottom: -20px;
        z-index: -1;
    }

    .AboutUs_divider__VmYxB {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        height: 10px;
        border-radius: 0;
    }

    .AboutUs_webBanner__ovjNN {
        display: none;
    }

    .AboutUs_bannerText__Wkeir {
        min-width: 0;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }

    .AboutUs_bannerSubtitle__XXlUf {
        font-size: 18px;
    }

    .AboutUs_banner__1Tzy\\+ {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-size: cover;
        background-position: center;
        justify-content: center;
        align-items: bottom;
        height: 160px;
    }

    .AboutUs_bannerTitle__2XN7k {
        font-size: 40px;
    }
    .AboutUs_teamMember__c6i5o {
        justify-content: center;
        width: 100%;

    }
}

@media screen and (max-width: 768px) {
    .AboutUs_brandCardMain__IFcBw{
        width: 80%;
    }
    .AboutUs_brandCard__zO1bL {
        height: 150px;
    }
    .AboutUs_container__B9FnG {
        margin-top: 30px;
    }
    .AboutUs_teamMember__c6i5o {
        .AboutUs_teamMemberText__vw5a0 {
            width: 95%;
        }        
    }
}

@media screen and (max-width: 400px) {
    .AboutUs_buttons__-tyag button {
        width: 140px;
    }
    .AboutUs_buttonLabel__NWkMn {
        font-size: 20px;
    }
    .AboutUs_bannerSubtitle__XXlUf {
        font-size: 12px;
    }
    .AboutUs_teamBrands__Cw59a img {
        width: 26%;
    }
    .AboutUs_teamMember__c6i5o img {
        height: 150px;
    }
    .AboutUs_button__4S51Z {
        width: 90%;
        margin-top: 2em;
        font-size: 18px;
    }
    .AboutUs_brandCard__zO1bL {
        height: 100px;
    }
    .AboutUs_brandCard__zO1bL img {
        width: 55%;
    }
    .AboutUs_bubble__u5TXR {
        width: 100%;
        margin-top: 1em;    
        padding: 10px 0;
        font-size: 18px;
    }
    
}

@media screen and (max-width: 320px){
    .AboutUs_bannerTitle__2XN7k {
        font-size: 32px;
    }
    .AboutUs_buttons__-tyag button {
        width: 100px;
    }
    .AboutUs_buttonLabel__NWkMn {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutUs/AboutUs.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,yDAA+C;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,6DAA6D;IAC7D,cAAc;IACd,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,+CAA+C;IAC/C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,4BAA4B;AAChC;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;IACf;;IAEA;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yDAA+C;QAC/C,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,WAAW;;IAEf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI;YACI,UAAU;QACd;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,eAAe;QACf,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".banner {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    background-image: url(../../assets/HERO-BG.png);\n    background-size: cover;\n    background-position: center;\n    height: 250px;\n    position: relative;\n    z-index: -1;\n}\n\n.bannerText {\n    padding: 0 0 0 5%;\n    min-width: 400px;\n}\n\n.bannerTitle {\n    font-size: 60px;\n    font-family: 'Cocon Bold', sans-serif;\n    padding-bottom: 10px;\n}\n\n.container {\n    margin: 50px 0px;\n}\n\n.bannerSubtitle {\n    font-size: 26px;\n    font-weight: 700;\n    margin: 0;\n    padding-left: 5px;\n}\n\n.webBanner {\n    position: relative;\n    right: 0;\n    width: 60%;\n}\n\n.divider {\n    height: 22px;\n    width: 90%;\n    margin-left: 90px;\n    margin-right: 90px;\n    background-color: #69bf4a;\n    position: absolute;\n    bottom: -11px;\n    border-radius: 999px;\n}\n\n.buttons {\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n.buttons button {\n    position: relative;\n    background: transparent;\n    padding: 0px 10px 0px 10px;\n    border-radius: 14px;\n    color: #fff;\n    cursor: pointer;\n    border: 2px solid transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 51px;\n    width: 170px;\n    z-index: 1;\n}\n.buttons a {\n    text-decoration: none;\n}\n.buttons .Safety {\n    background: #69bf4a;\n}\n.buttons .Safety img {\n    height: 40px;\n    position: relative;\n    bottom: 5px;\n    z-index: -1;\n}\n.buttonLabel {\n    font-weight: 800;\n    font-size: 24px;\n}\n\n.featured {\n    margin-top: 28px;\n}\n.featuredTitle {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 38px;\n    line-height: 75px;\n    text-align: center;\n    margin: 0;\n    font-family: 'Cocon Bold', sans-serif;\n}\n\n.teamBrands {\n    width: 90%;\n    display: flex;\n    gap: 20px;\n    margin: 0 auto;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n.teamBrands img {\n    width: 18%;\n    height: auto;\n    cursor: pointer;\n}\n.bubble {\n    width: 90%;\n    background-image: linear-gradient(to right, #2acdc2, #63c15f);\n    margin: 0 auto;\n    margin-top: 2em;    \n    color: #fff;\n    border-radius: 99px;\n    text-align: center;\n    padding: 15px 0;\n    font-size: 28px;\n    font-family: 'Cocon Bold', sans-serif;\n}\n\n.teamMember {\n    display: flex;\n    width: 90%;\n    gap: 11px;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-top: 28px;\n    justify-content: center;\n}\n\n.teamMember span {\n    margin: o;\n    font-size: 14px;\n}\n\n.teamMember img {\n    height: 250px;\n}\n\n.teamMember  .teamMemberText {\n    width: 57%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.teamMember h4 {\n    font-size: 28px;\n    margin: 5px auto;\n}\n\n.teamMember h6 {\n    font-size: 14px;\n    margin: 5px auto;\n}\n\n.teamMember p {\n    font-style: normal;\n    font-size: 14px;\n    line-height: 1.5em;\n    text-align: center;\n}\n.teamMember .firstSentence {\n    font-weight: 700;\n}\n\n.brandCard {\n    width: 100%;\n    height: 200px;\n    background: transparent;\n    box-shadow: 0px 0px 8.486px rgba(0, 0, 0, 0.24);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 18px;\n}\n.brandCard img {\n    width: 35%;\n    height: auto;\n    object-fit: contain;\n}\n.brandCardMain{\n    width:40%;\n}\n.brandCardMain p {\n    font-size: 14px;\n    font-weight: 500;\n    margin: 11px auto;\n    text-align: center;\n}\n.articlesContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin-top: 18px;\n    gap: 2em;\n}\n.glow {\n    box-shadow: 0 0 30px #00ff00;\n}\n\n\n@media screen and (max-width: 1160px) {\n    .bannerSubtitle {\n        font-size: 20px;\n    }\n\n    .webBanner {\n        opacity: 30%;\n    }\n}\n\n@media screen and (max-width: 1035px) {\n    .featured {\n        margin-top: 18px;\n    }\n    .featuredTitle {\n        font-style: normal;\n        font-size: 24px;\n        line-height: 75px;\n    }\n    .buttonArrow {\n        height: 35px;\n        bottom: -20px;\n        z-index: -1;\n    }\n\n    .divider {\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n        height: 10px;\n        border-radius: 0;\n    }\n\n    .webBanner {\n        display: none;\n    }\n\n    .bannerText {\n        min-width: 0;\n        margin: 0 auto;\n        padding: 0;\n        text-align: center;\n    }\n\n    .bannerSubtitle {\n        font-size: 18px;\n    }\n\n    .banner {\n        background-image: url(../../assets/HERO-BG.png);\n        background-size: cover;\n        background-position: center;\n        justify-content: center;\n        align-items: bottom;\n        height: 160px;\n    }\n\n    .bannerTitle {\n        font-size: 40px;\n    }\n    .teamMember {\n        justify-content: center;\n        width: 100%;\n\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .brandCardMain{\n        width: 80%;\n    }\n    .brandCard {\n        height: 150px;\n    }\n    .container {\n        margin-top: 30px;\n    }\n    .teamMember {\n        .teamMemberText {\n            width: 95%;\n        }        \n    }\n}\n\n@media screen and (max-width: 400px) {\n    .buttons button {\n        width: 140px;\n    }\n    .buttonLabel {\n        font-size: 20px;\n    }\n    .bannerSubtitle {\n        font-size: 12px;\n    }\n    .teamBrands img {\n        width: 26%;\n    }\n    .teamMember img {\n        height: 150px;\n    }\n    .button {\n        width: 90%;\n        margin-top: 2em;\n        font-size: 18px;\n    }\n    .brandCard {\n        height: 100px;\n    }\n    .brandCard img {\n        width: 55%;\n    }\n    .bubble {\n        width: 100%;\n        margin-top: 1em;    \n        padding: 10px 0;\n        font-size: 18px;\n    }\n    \n}\n\n@media screen and (max-width: 320px){\n    .bannerTitle {\n        font-size: 32px;\n    }\n    .buttons button {\n        width: 100px;\n    }\n    .buttonLabel {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `AboutUs_banner__1Tzy+`,
	"bannerText": `AboutUs_bannerText__Wkeir`,
	"bannerTitle": `AboutUs_bannerTitle__2XN7k`,
	"container": `AboutUs_container__B9FnG`,
	"bannerSubtitle": `AboutUs_bannerSubtitle__XXlUf`,
	"webBanner": `AboutUs_webBanner__ovjNN`,
	"divider": `AboutUs_divider__VmYxB`,
	"buttons": `AboutUs_buttons__-tyag`,
	"Safety": `AboutUs_Safety__-NE4m`,
	"buttonLabel": `AboutUs_buttonLabel__NWkMn`,
	"featured": `AboutUs_featured__Eq18N`,
	"featuredTitle": `AboutUs_featuredTitle__WJo0V`,
	"teamBrands": `AboutUs_teamBrands__Cw59a`,
	"bubble": `AboutUs_bubble__u5TXR`,
	"teamMember": `AboutUs_teamMember__c6i5o`,
	"teamMemberText": `AboutUs_teamMemberText__vw5a0`,
	"firstSentence": `AboutUs_firstSentence__+W5cR`,
	"brandCard": `AboutUs_brandCard__zO1bL`,
	"brandCardMain": `AboutUs_brandCardMain__IFcBw`,
	"articlesContainer": `AboutUs_articlesContainer__BMnrv`,
	"glow": `AboutUs_glow__mF1Yr`,
	"buttonArrow": `AboutUs_buttonArrow__2S6a+`,
	"button": `AboutUs_button__4S51Z`
};
export default ___CSS_LOADER_EXPORT___;
